export const tourSteps = [
  {
    element: '[data-intro="product-usage-table"]',
    intro: "This table displays aggregated product usage data across all diet recommendations. Products are sorted by usage count by default. Click on column headers to sort by different fields.",
    position: 'top'
  },
  {
    element: '[data-intro="download-button"]',
    intro: "Download the filtered data as Excel (.xlsx) or CSV file. The download includes all matching products based on your current filters, not just the current page.",
    position: 'bottom'
  },
  {
    element: '[data-intro="pagination"]',
    intro: "Navigate through pages of results and adjust the number of items displayed per page. Use the arrows to move between pages.",
    position: 'top'
  },
  {
    element: '[data-intro="filter-toggle"]',
    intro: "Click here to show or hide the filter options. Use filters to narrow down results by date range, country, and search terms.",
    position: 'top'
  }
];
